import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import TractorSubsidy from "@/pages/TractorSubsidy";
import Pmksy from "@/pages/Pmksy";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Schemes from "@/pages/Schemes";
import SchemeInfo from "@/pages/SchemeInfo";
import Login from "@/pages/Login";
import StaffLogin from "@/pages/StaffLogin";
import AuthCallback from "@/pages/AuthCallback";
import ApplicationForm from "@/pages/ApplicationForm";
import FarmerDashboard from "@/pages/FarmerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import StaffDashboard from "@/pages/StaffDashboard";
import ZoneManagement from "@/pages/ZoneManagement";
import StaffManagement from "@/pages/StaffManagement";
import TaskManagement from "@/pages/TaskManagement";
import SystemSettings from "@/pages/SystemSettings";

function AppRoutes() {
  const location = useLocation();
  // Process the OAuth redirect FIRST (synchronously) to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/schemes" element={<Schemes />} />
      <Route path="/scheme/:code" element={<SchemeInfo />} />
      <Route path="/tractor-subsidy" element={<TractorSubsidy />} />
      <Route path="/pmksy" element={<Pmksy />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin/login" element={<StaffLogin />} />
      <Route path="/apply" element={<ProtectedRoute><ApplicationForm /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><FarmerDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute staffOnly><StaffDashboard /></ProtectedRoute>} />
      <Route path="/admin/applications" element={<ProtectedRoute staffOnly><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/zones" element={<ProtectedRoute staffOnly module="zone_management"><ZoneManagement /></ProtectedRoute>} />
      <Route path="/admin/staff" element={<ProtectedRoute staffOnly module="staff_management"><StaffManagement /></ProtectedRoute>} />
      <Route path="/admin/tasks" element={<ProtectedRoute staffOnly module="task_assignment"><TaskManagement /></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute staffOnly module="system_settings"><SystemSettings /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
